// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3Lr9t","disabled":"FileBtn_disabled__EvMm9","warn":"FileBtn_warn__6PGMl","fade":"FileBtn_fade__28ya_"};